import { VrService } from './../../services/vr.service';
import { NavParams, ViewController } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'search.html',
    providers: [VrService]
})
export class VrAccountSearchPage {
    paras = {
        startDate: '',
        endDate: '',
        userName: '',
        changeType: '',
        pageIndex: 1,
        pageSize: 30,
    };
    changeTypes = [];

    constructor(
        private navpars: NavParams,
        private viewCtrl: ViewController,
        private vrService: VrService
    ) {
        this.paras = this.navpars.get('paras');
        this.vrService.getChangeTypes().then(s => {
            this.changeTypes = s;
        });
    }

    //确认按钮
    //TQQ 2018-01-26
    okSearch() {
        this.dismiss(this.paras);
    }

    //取消按钮
    //TQQ 2018-02-26
    dismiss(data?) {
        this.viewCtrl.dismiss(data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/vraccountreport/search.ts